import React, { useEffect, useState } from 'react';
import { Button } from './Button';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      // Show after scrolling down 500px
      if (window.pageYOffset > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 shadow-[0_-10px_20px_rgba(0,0,0,0.1)] p-4 z-40 md:hidden flex justify-center animate-fade-in-up" data-id="element-72">
      <Button href="https://www.digitalesia.shop/cart/52199768916261:1" fullWidth size="md" className="text-sm py-3" data-id="element-73">
        Acceder Ahora + 80 Blueprints
      </Button>
    </div>;
}